import { getTracker } from "@app/utils/window";

import {
  clickedUpdateEmailAddress,
  clickedDeleteBillingAddress,
  deletedBillingAddress,
  updatedUser,
  updatedBillingAddress
} from "../../../tracking/account-tracking";
import { failedRequest } from "../../../tracking/error-tracking";

export const updateEmailAddressClicked = () => {
  const tracker = getTracker();
  tracker.track(clickedUpdateEmailAddress());
};
export const deleteBillingAddressClicked = () => {
  const tracker = getTracker();
  tracker.track(clickedDeleteBillingAddress());
};

export const userUpdated = () => {
  const tracker = getTracker();
  tracker.track(updatedUser());
};
export const billingAddressDeleted = () => {
  const tracker = getTracker();
  tracker.track(deletedBillingAddress());
};

export const billingAddressUpdated = () => {
  const tracker = getTracker();
  tracker.track(updatedBillingAddress());
};

export const failedUpdateUser = (err: Error | null) => {
  const tracker = getTracker();
  tracker.track(failedRequest(err, "update_user", { section: "settings" }));
};
